module.exports = __webpack_public_path__ + "img/account-approved.d08c8f8a.svg";